<template>
    <div style="height: 100%; background: #F2F2F6">
      <el-header style="padding: 0px; margin-bottom: 40px">
        <el-row style="height: 60px; line-height: 60px; background-color: #044578;">
            <el-col :span="1" :offset="2" style="font-size: 30px;color: #ffffff">
                <div style="width: 100%; height: 100%; cursor: pointer" @click="ret">
                    <i class="el-icon-arrow-left"></i>
                </div>
            </el-col>
            <el-col :span="4"
            style="text-align: left;
                    font-size: 18px;
                    color: #ffffff;
                    font-weight: bold;">
                创建经销商账号
            </el-col>
        </el-row>
    </el-header>
    <el-row style="padding-top: 50px; width: 100%; margin: 0 auto">
      <el-col :span="8" :offset="7">
        <el-form
          :model="user"
          :rules="rules"
          ref="customerForm"
          label-width="100px"
          label-position="right"
        >
          <el-form-item label="用户名" prop="username">
            <el-input v-model="user.username" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="经销商名称" prop="name">
            <el-input
              v-model="user.name"
              maxlength="10"
            ></el-input>
          </el-form-item>
           <el-form-item label="密码" prop="password">
            <el-input
              v-model="user.password"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="手机号" prop="mobile">
            <el-input v-model="user.mobile" maxlength="11"></el-input>
          </el-form-item> -->
          <el-form-item label="城市" prop="city">
            <el-input v-model="user.city" placeholder="用与大屏显示，仅填写城市名称，如：“杭州”"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="user.address"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="createUser()">创建</el-button>
            <el-button type="info" @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from "vue";
import { hex_md5 } from "../../assets/js/md5";
export default {
    name: 'DealerAdd',
    data() {
        // var mobileCheck = (tule, value, callback) => {
     
        //     if (value&&(value.length != 11 || value[0] != 1)) {
        //         callback(new Error("请输入正确的手机号"));
        //     } else {
        //         callback();
        //     }
        // };
        var usernameCheck = (tule, value, callback) => {
          if(value.indexOf('@')>=0){
             callback(new Error("用户名中不能使用@"));
          }else{
            callback();
          }
        };
        var passwordCheck = (tule, value, callback) => {
            if (value.length < 6) {
                callback(new Error("密码不能小于6位"));
            } else {
                callback();
            }
        };
        return {
            sessionid: "",
            checked: true,
            user: {
                innerid: "",
                // mobile: "",
                password:'',
                passwordnew: "",
                name: "",
                username: "",
                address: '',
                city: ''
            },
            time: "",
            rules: {
                username:[
                  { required: true, message: "请输入用户名", trigger: "blur" },
                  { validator: usernameCheck, trigger: "blur" },
                ],
                name: [{ required: true, message: "请输入名称", trigger: "blur" },],
                password: [
                { required: true, message: "请输入密码", trigger: "blur" },
                { validator: passwordCheck, trigger: "blur" },
                ],
            },
        }
    },
    mounted: function() {
    },
    methods: {
    createUser() {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self=this;
          // debugger;
          self.user.passwordnew=hex_md5(self.user.password);
          Vue.axios.post("/aio/dealer/add", {
            name: self.user.name,
            username: self.user.username,
            password: self.user.passwordnew,
            // mobile: self.user.mobile,
            address: self.user.address,
            city: self.user.city
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.$message({
                message: "用户创建成功",
                type: "success",
              });
              this.$router.back();
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || "发生未知错误，请联系相关人员查看",
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    back() {
      this.$router.back();
    },
    ret() {
      this.$router.back();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/DealerAdd.vue